const configs = {
  mashina: {
    appName: "Mashina",
    logo: "/Masina_ logo.jpg",
    logoAlt: "Mashina",
    bgColor: "#f8f8f8",
    textColor: "#111",
    sidebarBg: "#fff",
    sidebarBorder: "0.5px solid #eee",
    navColor: "#888",
    navActiveColor: "#E24B4A",
    navActiveBg: "#fafafa",
    logoutColor: "#aaa",
    btnColor: "#111",
    btnBorder: "0.5px solid #ccc",
    dangerColor: "#E24B4A",
    tabBg: "#f0f0f0",
    tabActiveBg: "#fff",
    tabActiveColor: "#111",
    tabInactiveColor: "#555",
    tableHeaderColor: "#888",
    tableTextColor: "#111",
    cardBg: "#fff",
    cardBorder: "0.5px solid #eee",
    inputBg: "#fff",
    inputBorder: "0.5px solid #ccc",
  },
  upstore: {
    appName: "UP Store",
    logo: "/Upstore logo 180.png",
    logoAlt: "UP Store",
    bgColor: "#202236",
    textColor: "#fff",
    sidebarBg: "#202236",
    sidebarBorder: "0.5px solid rgba(255,255,255,0.1)",
    navColor: "rgba(255,255,255,0.6)",
    navActiveColor: "#fff",
    navActiveBg: "rgba(255,255,255,0.08)",
    logoutColor: "rgba(255,255,255,0.4)",
    btnColor: "#fff",
    btnBorder: "0.5px solid rgba(255,255,255,0.25)",
    dangerColor: "#111",
    tabBg: "#ffbe78",
    tabActiveBg: "rgba(0,0,0,0.12)",
    tabActiveColor: "#333",
    tabInactiveColor: "#555",
    tableHeaderColor: "#111",
    tableTextColor: "#111",
    cardBg: "#a7c4f8",
    cardBorder: "0.5px solid rgba(167,196,248,0.4)",
    inputBg: "rgba(255,255,255,0.08)",
    inputBorder: "0.5px solid rgba(255,255,255,0.2)",
  },
};

export default configs[process.env.REACT_APP_BRAND] || configs.mashina;
